import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { LASERCUT } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Catalog = ({ onSelectCategory }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Failed loading products", err));
  }, []);

  return (
    <section id="katalog" className="relative bg-ink py-24 md:py-36 px-6 md:px-12 lg:px-24">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.25em] text-brass">Katalog Produk</span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl tracking-tight text-chromed mt-4">
            6 kategori. Semua 100% custom.
          </h2>
        </div>
        <p className="text-chromed/60 max-w-sm">
          Pilih kategori sebagai titik awal — ukuran, motif, dan warna finishing tetap sepenuhnya
          mengikuti kebutuhan Anda.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p, i) => (
          <motion.div
            key={p.slug}
            data-testid={LASERCUT.catalogCard(p.slug)}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
            className="group relative border border-linecol bg-surfacedark"
          >
            <div className="relative aspect-square overflow-hidden arch-frame">
              <img
                src={p.image_url}
                alt={p.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/10 to-transparent opacity-70" />
              <span className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.2em] bg-brass text-ink px-3 py-1">
                {p.tag}
              </span>
            </div>
            <div className="p-6">
              <h3 className="font-heading text-xl md:text-2xl text-chromed mb-2">{p.category_label}</h3>
              <p className="text-sm text-chromed/60 leading-relaxed mb-5">{p.description}</p>
              <button
                data-testid={LASERCUT.catalogCtaButton(p.slug)}
                onClick={() => onSelectCategory(p.slug)}
                className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-brass hover:text-brass-light transition-colors"
              >
                Konsultasi Kategori Ini <ArrowUpRight size={16} />
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
